export const AUTH_REQUEST = "AUTHORIZATION:AUTH_REQUEST"
export const AUTH_SUCCESS = "AUTHORIZATION:AUTH_SUCCESS"
export const AUTH_FAILURE = "AUTHORIZATION:AUTH_FAILURE"
export const AUTH_LOGOUT = "AUTHORIZATION:AUTH_LOGOUT"
export const REFRESH_TOKEN_REQUEST = "AUTHORIZATION:REFRESH_TOKEN_REQUEST"
export const REFRESH_TOKEN_SUCCESS = "AUTHORIZATION:REFRESH_TOKEN_SUCCESS"
export const REFRESH_TOKEN_FAILURE = "AUTHORIZATION:REFRESH_TOKEN_FAILURE"
